import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4g08uuakiy: FaireBrandEntity = {
  token: "b_4g08uuakiy",
  type: "brand",
  name: "Portland Bee Balm",
  avatarUrl:
    "https://cdn.faire.com/fastly/4903d6ae4e8868ed7fda41989ca93a2e1d1b965e25aa120f81c1c2be57d569f0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cd45033268afdc2e76d985545a18f27f732b415d184394f404192f0524d5018b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4903d6ae4e8868ed7fda41989ca93a2e1d1b965e25aa120f81c1c2be57d569f0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cd45033268afdc2e76d985545a18f27f732b415d184394f404192f0524d5018b.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 247,
  isTopShop: true,
  isInsider: true,
  description:
    "Portland Bee Balm creates handmade beeswax lip balms, salves, soaps, and raw unfiltered honey rooted in sustainability and simplicity. Founded by beekeeper and woodworker Brad and his wife Anika in Portland, Oregon, the brand began with a single goal: to make the best natural lip balm using beeswax from Pacific Northwest hives.\n\nEach balm is made with just a few clean, organic ingredients—local beeswax, coconut oil, and olive oil—delivering natural hydration without harsh chemicals, fragrances, or fillers. Products are wrapped in sustainable labels and displayed in artisan-crafted wooden displays designed for boutiques, wellness shops, and gift stores.\n\nRetailers trust Portland Bee Balm for its eco-friendly values, repeat customer demand, and premium merchandising displays. Our beeloved customers return for the quality, purity, and story: natural products that nourish lips and skin, support beekeepers, and help protect pollinators.\n\nWith Portland Bee Balm, you’re stocking natural, sustainable, and best-selling everyday naturals that support both people and the planet.\n\nSimple. Honest. Natural",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:48.532Z",
    importedBy: "entity-db-cli",
  },
};
